import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, HStack, Modal, theme, useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

export const ConfirmLocationLayoutFooter = ({
  isLoading,
  onContinue,
  onMoreLocations,
}: ConfirmLocationModalFooterProps) => {
  const { t } = useLocalizationContext();
  const { minWidth } = useResponsive();

  return (
    <Modal.Footer style={styles.footer} withoutTopBorder={minWidth.tablet}>
      <HStack
        itemsPerRow={onMoreLocations ? 2 : 1}
        customSpacing={theme.spacing.medium}
      >
        {onMoreLocations ? (
          <Button
            size="large"
            palette="secondary"
            onPress={onMoreLocations}
            disabled={isLoading}
            testID="confirm-location.more-locations"
            accessibilityLabel={t('location.more-locations')}
            accessibilityHint={t('location.more-locations')}
          >
            {t('location.more-locations')}
          </Button>
        ) : null}

        <Button
          size="large"
          onPress={onContinue}
          isLoading={isLoading}
          testID="confirm-location.continue"
          accessibilityLabel={t('location.continue')}
          accessibilityHint={t('location.continue')}
        >
          {t('location.continue')}
        </Button>
      </HStack>
    </Modal.Footer>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingTop: theme.spacing.medium,
    paddingHorizontal: theme.spacing.medium,
  },
});

export type ConfirmLocationModalFooterProps = {
  readonly isLoading: boolean;
  readonly onContinue: () => void;
  readonly onMoreLocations?: () => void;
};
